import { CmsApplianceDetailsAdditionalAppliancesBenefitsPanel } from '../../models/appliance-details-additional-appliances/cms-appliance-details-additional-appliances-benefits-panel.interface';

export const mockCmsApplianceDetailsAdditionalAppliancesBenefitsPanel: CmsApplianceDetailsAdditionalAppliancesBenefitsPanel =
  {
    benefits: {
      item0: {
        body: 'Benefit 1',
        icon: {
          name: 'shield-check',
        },
      },
      item1: {
        body: 'Benefit 2',
        icon: {
          name: 'dog',
        },
      },
      item2: {
        body: '<strong>Benefit 3</strong>',
        icon: {
          name: 'horse',
        },
      },
    },
  };
